import { useMemo } from 'react'
import { RenderBlock } from '../../../../../types'
import { MainBlockType } from './types'

type UseMainBlockTypeProps = {
	type: RenderBlock.MainBlockType
	settingType: RenderBlock.InitMain['setting_block']['type']
}

export const useMainBlockType = ({
	type,
	settingType,
}: UseMainBlockTypeProps): MainBlockType =>
	useMemo(() => {
		if (type === 'none') return 'none'

		if (type === 'simple') return 'simple'

		if (
			type === 'half' &&
			['iphone', 'iphone-iphone', 'mac', 'ipad', 'iphone-mac', 'none'].includes(
				settingType
			)
		)
			return 'device'

		if (type === 'half') return 'half'

		return 'default'
	}, [type, settingType])
